// extracted by mini-css-extract-plugin
module.exports = {"container":"WeekPicker_container__1wQJo","arrowButton":"WeekPicker_arrowButton__3xokK","arrow":"WeekPicker_arrow__267A6","title":"WeekPicker_title__233sa"};